import { roundCurrency } from "../../util/bankersRound";

const data = (state) => ({
    datasets: [{
        data: [
            roundCurrency((state.PAYMENT + state.EXTRA_MONTHLY_PAYMENT_AMOUNT) / 100),
            roundCurrency((state.INSURANCE_COST) / 100),
            roundCurrency((state.PROPERTY_TAX) / 100),
            roundCurrency((state.HOA_FEES) / 100)
        ],

        backgroundColor: [
            '#acd14d',
            '#62c5b4',
            '#153763',
            '#7b7b7b'
        ],

    }],
    labels: [
        'Principle & Interest',
        `Homeowner's Insurance`,
        'Property Tax',
        'HOA Fees'
    ]
});
const options = {
    cutoutPercentage: 72,
    aspectRatio: 1,
    legend: {
        display: false
    }
};

export default (state) => {
    return {
        type: 'doughnut',
        data: data(state),
        options,
    }
};